import { Post, User, Message } from '../types';

// Mock Users
export const mockUsers: User[] = [
  {
    id: '1',
    name: 'Maria Rodriguez',
    email: 'maria@example.com',
    role: 'athlete',
    sport: 'Soccer',
    avatar: 'https://images.pexels.com/photos/3763188/pexels-photo-3763188.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    bio: 'Professional soccer player with 5+ years of experience',
    stats: {
      matches: 120,
      achievements: 15,
      followers: 1250,
      following: 345
    },
    verified: true,
    createdAt: '2022-03-15T12:00:00Z',
    location: 'Madrid, Spain'
  },
  {
    id: '2',
    name: 'Sophia Williams',
    email: 'sophia@example.com',
    role: 'athlete',
    sport: 'Tennis',
    avatar: 'https://images.pexels.com/photos/3764013/pexels-photo-3764013.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    bio: 'Tennis player passionate about the sport since childhood',
    stats: {
      matches: 87,
      achievements: 8,
      followers: 975,
      following: 412
    },
    verified: true,
    createdAt: '2022-05-20T10:30:00Z',
    location: 'London, UK'
  },
  {
    id: '3',
    name: 'Olivia Martinez',
    email: 'olivia@example.com',
    role: 'athlete',
    sport: 'Swimming',
    avatar: 'https://images.pexels.com/photos/3764574/pexels-photo-3764574.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    bio: 'Olympic swimmer specializing in freestyle and butterfly',
    stats: {
      matches: 45,
      achievements: 12,
      followers: 2350,
      following: 183
    },
    verified: true,
    createdAt: '2022-04-10T15:45:00Z',
    location: 'Sydney, Australia'
  },
  {
    id: '4',
    name: 'Emma Johnson',
    email: 'emma@example.com',
    role: 'coach',
    sport: 'Basketball',
    avatar: 'https://images.pexels.com/photos/3764011/pexels-photo-3764011.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    bio: 'Professional basketball coach with focus on youth development',
    stats: {
      achievements: 7,
      followers: 845,
      following: 231
    },
    verified: true,
    createdAt: '2022-02-28T09:15:00Z',
    location: 'Chicago, USA'
  },
  {
    id: '5',
    name: 'Isabella Brown',
    email: 'isabella@example.com',
    role: 'athlete',
    sport: 'Gymnastics',
    avatar: 'https://images.pexels.com/photos/1858175/pexels-photo-1858175.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    bio: 'Competitive gymnast with a focus on floor and balance beam',
    stats: {
      matches: 32,
      achievements: 9,
      followers: 1120,
      following: 267
    },
    verified: false,
    createdAt: '2022-06-05T11:20:00Z',
    location: 'Toronto, Canada'
  }
];

// Mock Posts
const mockPosts: Post[] = [
  {
    id: '1',
    userId: '3',
    user: mockUsers.find(user => user.id === '3'),
    content: 'Just finished my morning training session! 🏊‍♀️ Feeling stronger every day. Anyone else working on improving their butterfly technique?',
    images: ['https://images.pexels.com/photos/1263349/pexels-photo-1263349.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'],
    likes: 68,
    comments: 12,
    createdAt: '2024-06-09T08:30:00Z',
    isLiked: false
  },
  {
    id: '2',
    userId: '1',
    user: mockUsers.find(user => user.id === '1'),
    content: 'Big game tomorrow! The team is ready and we\'ve been training hard for this moment. Wish us luck! ⚽ #GameDay #WomenInSports',
    likes: 142,
    comments: 28,
    createdAt: '2024-06-08T18:45:00Z',
    isLiked: true
  },
  {
    id: '3',
    userId: '2',
    user: mockUsers.find(user => user.id === '2'),
    content: 'So happy to announce my partnership with @SportsBrand! Excited to represent a company that supports women in sports. Here\'s to breaking barriers together! 🎾 #Sponsored',
    images: ['https://images.pexels.com/photos/5384429/pexels-photo-5384429.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'],
    likes: 215,
    comments: 42,
    createdAt: '2024-06-07T14:20:00Z',
    isLiked: false
  },
  {
    id: '4',
    userId: '4',
    user: mockUsers.find(user => user.id === '4'),
    content: 'Proud of my team for their performance today! Every player gave 100% and that\'s all I can ask for as a coach. We\'ll keep working on our defensive strategy for next week. 🏀 #CoachLife',
    likes: 89,
    comments: 15,
    createdAt: '2024-06-06T20:15:00Z',
    isLiked: false
  },
  {
    id: '5',
    userId: '5',
    user: mockUsers.find(user => user.id === '5'),
    content: 'Landed my first perfect double pike in competition today! All those extra hours in the gym finally paid off. Thanks to my amazing coach for believing in me! 🤸‍♀️ #Gymnastics #HardWorkPaysOff',
    video: 'https://example.com/video1.mp4', // This would be a real video URL in a production app
    likes: 178,
    comments: 31,
    createdAt: '2024-06-05T19:30:00Z',
    isLiked: false
  }
];

// Mock Messages
export const mockMessages: Message[] = [
  {
    id: '1',
    senderId: '2',
    recipientId: '1',
    content: 'Hey Maria! I saw your game yesterday. Great performance!',
    read: true,
    createdAt: '2024-06-08T10:15:00Z'
  },
  {
    id: '2',
    senderId: '1',
    recipientId: '2',
    content: 'Thanks Sophia! I appreciate it. How\'s your training going?',
    read: true,
    createdAt: '2024-06-08T10:30:00Z'
  },
  {
    id: '3',
    senderId: '2',
    recipientId: '1',
    content: 'It\'s going well! Preparing for the tournament next month.',
    read: true,
    createdAt: '2024-06-08T10:45:00Z'
  },
  {
    id: '4',
    senderId: '3',
    recipientId: '1',
    content: 'Hi Maria! Would you be interested in collaborating on a charity event for young female athletes?',
    read: false,
    createdAt: '2024-06-09T09:20:00Z'
  }
];

// Mock data fetch functions (simulates API calls)
export const getMockUsers = async (): Promise<User[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockUsers);
    }, 800);
  });
};

export const getMockUser = async (id: string): Promise<User | undefined> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockUsers.find(user => user.id === id));
    }, 500);
  });
};

export const getMockPosts = async (): Promise<Post[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockPosts);
    }, 1000);
  });
};

export const getMockUserPosts = async (userId: string): Promise<Post[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockPosts.filter(post => post.userId === userId));
    }, 800);
  });
};

export const getMockMessages = async (userId: string): Promise<Message[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockMessages.filter(msg => msg.senderId === userId || msg.recipientId === userId));
    }, 700);
  });
};